import { Link } from "react-router-dom";
import AppBreadcrumbs from "../../components/common/breadcrumbs/AppBreadcrumbs.jsx";
import TableProducts from "../../components/common/table/TableProducts.jsx";
import Page from "../../components/layout/Page.jsx";
import useProducts from "../../hooks/useProducts.jsx";

const Products = () => {
  const { data, loading, error, refetch } = useProducts();

  return (
    <Page>
      <AppBreadcrumbs currentPage="Productos" />
      <div className="flex justify-between items-center mb-8">
        <div>
          <h1 className="font-bold text-2xl">Productos</h1>
          <span>Lista de productos en venta</span>
        </div>

        <Link
          to={`/products/create`}
          className="text-sm bg-white text-blue-700 border border-blue-700 hover:bg-blue-700 hover:text-white font-bold py-1.5 px-4 rounded transition-colors"
        >
          Crear
        </Link>
      </div>

      <TableProducts data={data} error={error} loading={loading} refetch={refetch} />
    </Page>
  );
};

export default Products;
